import {all, fork, put, throttle} from 'redux-saga/effects';
import actions from './actions';
import AppActions from '../App/actions';

// Create field
export function* listenColumnWidth() {
    yield throttle(300, actions.LOCAL_STORAGE_SET_COLUMN_WIDTH, function* ({ width }) {
        yield put({ type: AppActions.APP_SET_RESIZE_EVENT, width });
    });
}

export default function* rootSaga() {
    yield all([
        fork(listenColumnWidth),
    ]);
}
